import { useRef } from "react";
import "./editorialForms.css";

export default function PdfForm({ data, onChange }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange({ ...data, pdfFile: file, pdfFileName: file.name });
    }
  };

  const categories = [
    "Documentacao",
    "Relatorio",
    "Apresentacao",
    "Manual",
    "Guia",
    "Formulario",
    "Contrato",
    "Curriculo",
    "Certificado",
    "Pesquisa",
    "Artigo",
    "Outro",
  ];

  return (
    <div className="editorial_form pdf_form">
      <div className="editorial_form_section">
        <label>
          Arquivo PDF <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => fileInputRef.current?.click()}>
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,application/pdf"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {data?.pdfFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
              </svg>
              <span>{data.pdfFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, pdfFile: null, pdfFileName: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload do PDF</p>
              <span>Arquivos PDF ate 50MB</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Titulo do Documento <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Relatorio Anual 2024"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="Descreva o conteudo do documento..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione</option>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Autor/Organizacao</label>
          <input
            type="text"
            placeholder="Nome ou organizacao"
            value={data?.author || ""}
            onChange={(e) => onChange({ ...data, author: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Data do Documento</label>
          <input
            type="date"
            value={data?.documentDate || ""}
            onChange={(e) => onChange({ ...data, documentDate: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Numero de Paginas</label>
        <input
          type="number"
          placeholder="Ex: 25"
          value={data?.pageCount || ""}
          onChange={(e) =>
            onChange({ ...data, pageCount: parseInt(e.target.value) || 0 })
          }
        />
      </div>

      <div className="editorial_form_section">
        <label>Idioma</label>
        <select
          value={data?.language || "pt"}
          onChange={(e) => onChange({ ...data, language: e.target.value })}
        >
          <option value="pt">Portugues</option>
          <option value="en">Ingles</option>
          <option value="es">Espanhol</option>
          <option value="fr">Frances</option>
          <option value="de">Alemao</option>
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Opcoes</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="allowDownload"
              checked={data?.allowDownload !== false}
              onChange={(e) =>
                onChange({ ...data, allowDownload: e.target.checked })
              }
            />
            <label htmlFor="allowDownload">Permitir download</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="allowPrint"
              checked={data?.allowPrint !== false}
              onChange={(e) =>
                onChange({ ...data, allowPrint: e.target.checked })
              }
            />
            <label htmlFor="allowPrint">Permitir impressao</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isPublic"
              checked={data?.isPublic !== false}
              onChange={(e) =>
                onChange({ ...data, isPublic: e.target.checked })
              }
            />
            <label htmlFor="isPublic">Documento publico</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip pdf_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
        </svg>
        <span>
          Compartilhe documentos PDF com sua rede. Ideal para relatorios,
          apresentacoes e materiais de referencia.
        </span>
      </div>
    </div>
  );
}
